(() => {
  const init = () => {
    const button = document.querySelector('.digicorner-scroll-up');
    if (!button) return;

    const getScroller = () => {
      const candidates = [document.scrollingElement, document.documentElement, document.body, document.querySelector('.page-wrapper')].filter(Boolean);
      return candidates.find(el => el.scrollHeight > el.clientHeight + 50) || document.scrollingElement || document.documentElement;
    };

    const scroller = getScroller();

    const getTop = () => Math.max(
      window.scrollY || 0,
      window.pageYOffset || 0,
      document.documentElement?.scrollTop || 0,
      document.body?.scrollTop || 0,
      scroller?.scrollTop || 0
    );

    const update = () => {
      button.classList.toggle('is-visible', getTop() > 350);
    };

    button.addEventListener('click', (e) => {
      e.preventDefault();
      try {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        document.documentElement.scrollTo({ top: 0, behavior: 'smooth' });
        document.body.scrollTo({ top: 0, behavior: 'smooth' });
        if (scroller && scroller !== document.documentElement && scroller !== document.body) {
          scroller.scrollTo({ top: 0, behavior: 'smooth' });
        }
      } catch (_) {
        location.hash = 'header-group';
      }
    });

    window.addEventListener('scroll', update, { passive: true });
    document.addEventListener('scroll', update, { passive: true, capture: true });
    scroller?.addEventListener?.('scroll', update, { passive: true });
    update();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();